<template>
  <div>
    <div class="view" :class="{ 'app-view': !custom }">
      <slot></slot>
    </div>
    <div class="copyright">Copyright&copy; 2022 福音影视网.Madrid, Spain</div>
  </div>
</template>
<script>
export default {
  name: 'AppView',
  props: {
    custom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasActivated: false,
      hasDeactivated: false
    }
  },
  computed: {
    footVisible() {
      return this.$service.common.footVisible
    }
  },
  mounted() {
    if (this.$route.meta.isPush) {
      this.$emit('open')
      this.$nextTick(() => {
        document.body.scrollTop = 0
      })
    } else {
      this.$emit('restore')
      this.$nextTick(() => {
        document.body.scrollTop = this.$route.meta.scrollTop
      })
    }
    this.hasActivated = true
  },
  activated() {
    if (!this.hasActivated) {
      if (this.$route.meta.isPush) {
        this.$emit('open')
        this.$nextTick(() => {
          document.body.scrollTop = 0
        })
      } else {
        this.$emit('restore')
        this.$nextTick(() => {
          document.body.scrollTop = this.$route.meta.scrollTop
        })
      }
      this.hasActivated = true
      this.hasDeactivated = false
    }
  },
  deactivated() {
    if (this.$route.meta.isPush) {
      this.$emit('hide')
    } else {
      this.$emit('close')
    }
    this.hasDeactivated = true
    this.hasActivated = false
  },
  beforeDestroy() {
    if (!this.hasDeactivated) {
      if (this.$route.meta.isPush) {
        this.$emit('hide')
      } else {
        this.$emit('close')
      }
      this.hasDeactivated = true
    }
  }
}
</script>
<style scoped lang='scss'>
.app-view {
  min-height: calc(100vh - 100px);
}

.copyright {
  line-height: 50px;
  text-align: center;
  color: $thirdly-text-color;
}
</style>



// WEBPACK FOOTER //
// AppView.vue?38a3fb27